<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="op">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
        <b-card class="pr-4">
          <div v-for="(prop, index) in equipments" :key="prop.caption + index">
            <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>
        <div class="attr-list">
          <div class="inp">
            <label>{{ $t('taxa-de-embebicao') }}</label>
            <input
              class="inp-number input-pentagro"
              type="number"
              v-model="TL.value"
            >
          </div>
          <div class="inp">
            <label>{{ $t('fracao-solidos-exceto-fibra') }}</label>
            <input
              min="0"
              step="0.1"
              class="inp-number input-pentagro"
              type="number"
              v-model="xSolidosNaoFibraTorta.value"
            >
          </div>
          <div class="inp">
            <label>{{ $t('area-m-1') }}</label>
            <p>{{ areaTotalDisponivelFiltracao.value | ParseNumber }}</p>
          </div>
          <div class="inp">
            <label>{{ $t('capacidade-de-filtracao-m-h') }}</label>
            <p>{{ capacidadeFiltracao.value | ParseNumber }}</p>
          </div>
          <div class="inp">
            <label>{{ $t('kg-torta-tc-kg-tc') }}</label>
            <p>{{ producaoDeTorta.value | ParseNumber }}</p>
          </div>
          <div class="inp">
            <label>{{ $t('ocupacao-1') }}</label>
            <p>{{ taxaOcupacao.value | ParseNumber }}</p>
          </div>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="equip-joker">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput
              :text="joker.caption"
              @sendText="updateCaption($event, joker)"
            >
            </TextToInput>
          </div>
          <div class="b-layout-joker">
            <b-card>
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3">
              <div class="inp">
                <label>{{ $t('area-m-0') }} </label>
                <label class="input-data">{{ joker.areaTotalDisponivelFiltracao.value }}</label>
              </div>
              <div class="inp">
                <label>{{ $t('capacidade-de-filtracao-m-h-0') }} </label>
                <label class="input-data">{{ joker.capacidade.value }}</label>
              </div>
              <div class="inp">
                <label>{{ $t('ocupacao-0') }} </label>
                <label class="input-data">{{ joker.Ocupacao.value }}</label>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput";
import { FiltersMixin } from '../../../mixins/filtersMixin';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  components: { TextToInput },

  data() {
    return {
      TL: {},
      xSolidosNaoFibraTorta: {},
      areaTotalDisponivelFiltracao: {},
      capacidadeFiltracao: {},
      producaoDeTorta: {},
      taxaOcupacao: {},
      VazaoNominal: {},
      equipCapacity: [],
      operations: [{ value: null, text:this.$t('selecione-um-filtro') }],
      operationSelected: null,
      currents: [{ value: null, text:this.$t('selecione-um-filtro') }],
      current: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-um-filtro'),
      firstLoad: false,
      equipments: [],
      equipArea: [],
      tempAr: 0,
      attrList: [
        "TL",
        "xSolidosNaoFibraTorta",
        "areaTotalDisponivelFiltracao",
        "capacidadeFiltracao",
        "producaoDeTorta",
        "taxaOcupacao",
        "VazaoNominal"
      ],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.setAttrFilter3();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });

      this.updateNode();
      this.jokerEquipmentList = [];
    },

    current(value) {
      if (value) this.node.CurrentTempAr = value;
    },

    "TL.value"() {
      this.updateNode();
    },

    "xSolidosNaoFibraTorta.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.buildJokerEquipment(
          this.node.data[0].index,
          this.node.jokerCaption
        );
        this.setAttrFilter3();
        this.operationSelected = this.node.data[0].index;

        this.firstLoad = true;
        this.loadNotInput();
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
        
        if (p.equipName) {
          p.value = ParseToNumber(p.value) ? true : false;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    updateCaption(caption, joker) {
      joker.caption = caption;
      this.updateNode();
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Quantidade") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }

          if (props[p].caption == "Area") {
            this.equipArea.push(props[p]);
          }

          if (props[p].caption == "VazaoNominal") {
            this.equipCapacity.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
    },

    updateNode() {
      let attrs = [
        this.TL.clone(),
        this.xSolidosNaoFibraTorta.clone(),
      ];
      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList);
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Filtro3/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    ChangeArea() {
      if (this.areaTotalDisponivelFiltracao) {
        this.areaTotalDisponivelFiltracao.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipArea.find((c) => c.equipName == e.equipName);
          if (e.value && cap)
            this.areaTotalDisponivelFiltracao.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        });
      }
    },

    ChangeCapacity() {
      if (this.capacidadeFiltracao) {
        this.capacidadeFiltracao.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCapacity.find((c) => c.equipName == e.equipName);
          if (e.value && cap)
            this.capacidadeFiltracao.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        });
      }
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeArea();
      this.ChangeCapacity();
      this.switchStatusJoker(prop, this.equipments, false, this.ChangeArea);
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeArea();
    this.changeExternalCapacity = function () {
      this.ChangeArea();
      this.ChangeCapacity();
    };
    this.updataNodeInMixin = function () {
      this.updateNode();
    };
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.main {
  display: flex;
}

.main-config {
  width: 650px;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

.attr-list {
  width: 460px;
}

.card {
  margin: 10px;
}

input {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inp > p {
  margin-bottom: 1px;
}

.op {
  margin: 2%;
}

.equip-joker {
  margin-left: 7px;
}

.joker {
  width: 400px;
  margin-right: 10px;
  margin-top: 07px;
  padding: 10px;
  height: 350px;
  overflow-y: auto;
}

.b-layout-joker {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.b-form {
  color: #0009;
  width: 300px;
}
</style>